import { combineLatestWith, filter, ignoreElements, take, tap } from 'rxjs/operators';

import { sanitizeRequest, sanitizeResponse } from './logrocket-sanitizers';
import { LOGROCKET_APP_ID } from '../../../env';
import { RootEpic } from '../../../store/epics';
import { getPortalType } from '../../../utils/get-portal-type';
import { requestVerificationSuccess } from '../../account/reducer/session';
import { loadAnalyticsDataSuccess } from '../reducers/analytics-data';

const logRocketInitEpic: RootEpic = (action$, _state$, { api: { logrocket } }) =>
  action$.pipe(
    filter(requestVerificationSuccess.match),
    take(1),
    tap(() => {
      logrocket.init(LOGROCKET_APP_ID, {
        release: import.meta.env.MODE,
        dom: { inputSanitizer: true },
        network: {
          requestSanitizer: sanitizeRequest,
          responseSanitizer: sanitizeResponse,
        },
      });
    }),
    ignoreElements(),
  );

const logRocketIdentifyEpic: RootEpic = (action$, state$, { api: { logrocket } }) =>
  action$.pipe(
    filter(requestVerificationSuccess.match),
    combineLatestWith(action$.pipe(filter(loadAnalyticsDataSuccess.match))),
    tap(
      ([
        ,
        {
          payload: { userId, customerId },
        },
      ]) => {
        logrocket.identify(userId, {
          email: state$.value.preliminaryInfo.info.email,
          phone: state$.value.preliminaryInfo.info.phone,
          customerId,
          portalType: getPortalType(),
          environment: import.meta.env.MODE,
        });
      },
    ),
    ignoreElements(),
  );

export { logRocketInitEpic, logRocketIdentifyEpic };
